import api from "./api";

export async function fetchAppBranding() {
  const response = await api.get("/get-app-logo");
  return response?.data?.dataset?.data || {};
}
